import { LocationStoreView } from '../../types/locations';
import { HStack, Box, Text } from '@cad-arc';
import { LocationSelectDispatchAreaDisplay } from '../common/location-select-dispatch-area-display';
import { getCrossStreetsString } from '../../helpers/location-display';
import { CommonSize, getOneSizeSmaller } from '../../../common/helpers/utils';

export function MapLocationMetadata(props: {
    selectedLocation?: LocationStoreView | null;
    size?: CommonSize;
}) {
    if (!props.selectedLocation) {
        return null;
    }

    const smallerSize = getOneSizeSmaller(props.size);

    return (
        <Box
            w="100%"
            bg="surface.accent"
            position="absolute"
            bottom={0}
            left={0}
            px={3}
            py={3}
            style={{ borderTop: '1px solid var(--arc-colors-border-default)' }}
        >
            <HStack spacing={1}>
                <Text fontSize={smallerSize} color="text.secondary">
                    D-Area:
                </Text>
                <LocationSelectDispatchAreaDisplay
                    location={props.selectedLocation}
                    size={smallerSize}
                />
            </HStack>
            <HStack spacing={1}>
                <Text fontSize={smallerSize} color="text.secondary">
                    Cross Streets:
                </Text>
                <Text fontSize={smallerSize}>
                    {getCrossStreetsString(props.selectedLocation, true)}
                </Text>
            </HStack>
        </Box>
    );
}
